import React from "react";
import { FiBell } from "react-icons/fi";
import {
  BannerSection,
  BannerCard,
  BannerInner,
  BannerIconWrap,
  BannerTextBlock,
  BannerTitle,
  BannerSubtitle,
  BannerCta,
} from "./styles";

interface Props {
  onOpenModal: () => void;
}

export default function PropertyRadarBanner({ onOpenModal }: Props) {
  return (
    <BannerSection>
      <BannerCard>
        <BannerInner>
          <BannerIconWrap aria-hidden>
            <FiBell size={26} strokeWidth={2} />
          </BannerIconWrap>
          <BannerTextBlock>
            <BannerTitle>Não encontrou o que procura?</BannerTitle>
            <BannerSubtitle>
              Ative o radar de imóveis e receba alertas por e-mail e WhatsApp quando
              surgir algo compatível com o que você busca.
            </BannerSubtitle>
          </BannerTextBlock>
        </BannerInner>
        <BannerCta type="button" onClick={onOpenModal}>
          Criar alerta
        </BannerCta>
      </BannerCard>
    </BannerSection>
  );
}
